var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.017 156.76C143.441 156.76 177.023 123.179 177.023 81.7541C177.023 40.3294 143.441 6.74805 102.017 6.74805C60.5921 6.74805 27.0107 40.3294 27.0107 81.7541C27.0107 123.179 60.5921 156.76 102.017 156.76Z",
    fill: "url(#paint0_linear_3371_24536)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.017 6.74805C61.1153 6.74805 27.884 39.4922 27.0508 80.1946C34.942 114.948 66.4958 145.232 102.017 145.232C138.477 145.232 170.241 113.752 176.927 77.951C174.946 38.2939 142.166 6.74805 102.017 6.74805Z",
    fill: "url(#paint1_linear_3371_24536)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.584 67.1169C168.775 32.7013 138.431 6.74805 102.017 6.74805C65.5236 6.74805 35.1311 32.8153 28.4092 67.342C30.8279 79.3184 37.4117 98.0696 55.3017 107.073C82.7574 120.89 151.485 105.279 161.893 94.5116C169.177 86.9765 173.82 75.4893 175.584 67.1169Z",
    fill: "url(#paint2_linear_3371_24536)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.892 52.0367C159.382 25.3973 132.881 6.74805 102.017 6.74805C70.1937 6.74805 43.0201 26.5756 32.123 54.5424C32.9673 63.686 37.1144 80.5607 55.8407 90.5645C82.04 104.561 117.032 102.049 118.467 101.332C119.903 100.613 164.585 75.0942 164.585 75.0942C164.585 75.0942 171.909 65.6425 170.892 52.0367Z",
    fill: "url(#paint3_linear_3371_24536)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.013 75.2524C165.013 42.4412 136.812 15.8418 102.024 15.8418C67.2351 15.8418 39.0342 42.4402 39.0342 75.2524C39.0342 91.722 46.1422 106.623 57.6194 117.384C67.047 107.959 102.024 72.0815 102.024 72.0815L146.028 117.744C157.735 106.956 165.013 91.9091 165.013 75.2524Z",
    fill: "url(#paint4_radial_3371_24536)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.691 69.2272C157.027 61.5611 148.434 51.9844 148.434 51.9844L132.642 57.5469C132.642 57.5469 111.109 67.2366 105.886 72.082C104.96 72.9402 104.373 73.6104 104.026 74.1606L146.028 117.745C157.736 106.957 165.013 91.9105 165.013 75.2529C165.013 73.2193 164.903 71.2088 164.691 69.2272Z",
    fill: "url(#paint5_linear_3371_24536)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6611 75.9891L79.0287 98.5145L97.7789 80.6304L95.9114 68.449C95.9114 68.449 93.7748 66.2034 92.0643 66.7916C90.3549 67.3817 55.6611 75.9891 55.6611 75.9891Z",
    fill: "url(#paint6_linear_3371_24536)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.762 26.667L120.362 31.0382H129.25C129.824 31.0382 130.399 31.1663 130.892 31.4614C132.133 32.2026 133.822 33.921 133.466 36.8109C132.974 40.813 131.013 42.4294 131.013 42.4294L134.584 44.584C134.584 44.584 138.463 40.2128 137.909 34.6092C137.533 30.8032 134.059 28.5025 131.869 27.4182C130.87 26.9241 129.778 26.666 128.663 26.666H118.762V26.667Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9594 26.667L83.3589 31.0382H74.4714C73.8973 31.0382 73.3221 31.1663 72.829 31.4614C71.5876 32.2026 69.8991 33.921 70.2552 36.8109C70.7474 40.813 72.7079 42.4294 72.7079 42.4294L69.1369 44.584C69.1369 44.584 65.2578 40.2128 65.812 34.6092C66.1881 30.8032 69.6621 28.5025 71.8517 27.4182C72.851 26.9241 73.9433 26.666 75.0576 26.666H84.9594V26.667Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6191 117.385C69.0073 128.063 84.6967 134.664 102.024 134.664C119.151 134.664 134.673 128.207 146.028 117.745L102.024 72.082C102.023 72.081 67.0468 107.959 57.6191 117.385Z",
    fill: "url(#paint7_linear_3371_24536)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.434 51.9833H113.918V38.4355H89.3586V51.9843H55.6611V75.9901H89.2085V132.863C89.2085 139.914 94.9251 145.631 101.976 145.631C109.027 145.631 114.744 139.914 114.744 132.863V75.9891H148.434V51.9833Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.561 18.0352C93.7632 18.0352 87.4414 24.1729 87.4414 31.744C87.4414 39.3151 93.7632 45.4528 101.561 45.4528C109.36 45.4528 115.681 39.3151 115.681 31.744C115.681 24.1729 109.36 18.0352 101.561 18.0352ZM101.748 38.5319C98.1754 38.5319 95.2786 35.6351 95.2786 32.0621C95.2786 28.4891 98.1754 25.5923 101.748 25.5923C105.321 25.5923 108.218 28.4891 108.218 32.0621C108.218 35.6351 105.321 38.5319 101.748 38.5319Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4143 54.3223H88.3863H88.2012H87.0049C87.0269 54.3793 87.9341 57.6952 90.3328 60.3069C92.7225 62.9167 96.6556 65.5494 102.523 65.5434C104.923 65.5444 107.004 64.8632 108.745 63.8539C111.358 62.3375 113.219 60.1039 114.442 58.2554C115.663 56.4059 116.296 54.3553 116.31 54.3223H114.89H114.882C114.78 54.5763 113.732 57.111 111.68 59.4757C110.655 60.659 109.381 61.8134 107.862 62.6646C106.34 63.5158 104.579 64.071 102.524 64.072C97.1087 64.066 93.6237 61.6993 91.4161 59.3107C90.3178 58.1163 89.5526 56.916 89.0655 56.0207C88.8224 55.5726 88.6483 54.5783 88.5363 54.3223H88.4143Z",
    fill: "#69E4E4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6124 54.3223H87.5994H87.5974H87.0043H83.2002C83.2252 54.5023 83.5453 58.8205 86.04 63.1577C87.2903 65.3203 89.1179 67.544 91.7526 69.2194C93.8562 70.5628 96.4719 71.5141 99.5808 71.8422V132.253C99.5808 133.471 100.568 134.46 101.787 134.46C103.006 134.46 103.994 133.472 103.994 132.253V71.8742C107.093 71.5771 109.713 70.5938 111.81 69.2004C113.715 67.9421 115.198 66.3806 116.344 64.7762C118.065 62.3665 119.047 59.8608 119.622 57.9433C120.195 56.0247 120.355 54.4163 120.367 54.3223H115.984C115.979 54.4253 115.483 57.7702 113.48 61.1042C112.475 62.7856 111.118 64.3931 109.292 65.5764C107.461 66.7557 105.153 67.56 102.003 67.566H102C98.5355 67.56 96.0438 66.7127 94.1232 65.4984C92.6848 64.5831 91.5625 63.4378 90.6723 62.2035C89.3379 60.356 88.5487 58.3034 88.1136 56.7249C87.8955 55.9367 87.7645 54.7814 87.6895 54.3233H87.6124V54.3223Z",
    fill: "#122045"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96777 172.611H11.5665V175.434H8.32055V192.374H5.21468V175.434H1.96777V172.611Z",
    fill: "#38879F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1393 192.374C20.9703 191.866 20.8572 191.556 20.8572 189.945V186.84C20.8572 185.006 20.2361 184.328 18.8247 184.328H17.7514V192.374H14.6465V172.611H19.3328C22.5507 172.611 23.9341 174.108 23.9341 177.157V178.71C23.9341 180.742 23.2849 182.041 21.9015 182.69V182.746C23.454 183.395 23.9621 184.864 23.9621 186.925V189.974C23.9621 190.933 23.9901 191.64 24.3012 192.374H21.1393ZM17.7504 175.434V181.505H18.9647C20.122 181.505 20.8282 180.997 20.8282 179.415V177.467C20.8282 176.055 20.3481 175.434 19.2478 175.434H17.7504Z",
    fill: "#38879F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7685 192.374H34.6346L34.0984 188.788H30.2874L29.7502 192.374H26.8994L30.0613 172.611H34.6066L37.7685 192.374ZM30.6815 186.106H33.6743L32.2069 176.112H32.1509L30.6815 186.106Z",
    fill: "#38879F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7551 178.06H43.6991V192.374H40.9043V172.611H44.8004L47.9343 184.441H47.9903V172.611H50.7571V192.374H47.5662L43.7551 178.06Z",
    fill: "#38879F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8888 172.387C61.9096 172.387 63.462 174.193 63.462 177.355V177.976H60.5262V177.158C60.5262 175.747 59.9621 175.211 58.9738 175.211C57.9855 175.211 57.4214 175.747 57.4214 177.158C57.4214 178.598 58.0425 179.671 60.0751 181.449C62.6728 183.736 63.4911 185.373 63.4911 187.632C63.4911 190.794 61.9106 192.6 58.8608 192.6C55.8119 192.6 54.2305 190.794 54.2305 187.632V186.418H57.1663V187.829C57.1663 189.24 57.7875 189.749 58.7757 189.749C59.764 189.749 60.3852 189.24 60.3852 187.829C60.3852 186.389 59.764 185.316 57.7314 183.538C55.1337 181.251 54.3155 179.614 54.3155 177.355C54.3155 174.193 55.8679 172.387 58.8888 172.387Z",
    fill: "#38879F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1967 177.496V180.064C76.1967 183.226 74.6723 184.949 71.5664 184.949H70.098V192.374H66.9932V172.611H71.5664C74.6723 172.611 76.1967 174.333 76.1967 177.496ZM70.098 175.434V182.125H71.5664C72.5547 182.125 73.0909 181.673 73.0909 180.261V177.297C73.0909 175.885 72.5547 175.433 71.5664 175.433H70.098V175.434Z",
    fill: "#38879F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0438 192.374H85.91L85.3738 188.788H81.5628L81.0266 192.374H78.1748L81.3367 172.611H85.882L89.0438 192.374ZM81.9579 186.106H84.9507L83.4833 176.112H83.4273L81.9579 186.106Z",
    fill: "#38879F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7008 192.374C98.5318 191.866 98.4187 191.556 98.4187 189.945V186.84C98.4187 185.006 97.7986 184.328 96.3862 184.328H95.3129V192.374H92.208V172.611H96.8943C100.113 172.611 101.496 174.108 101.496 177.157V178.71C101.496 180.742 100.846 182.041 99.463 182.69V182.746C101.016 183.395 101.525 184.864 101.525 186.925V189.974C101.525 190.933 101.553 191.64 101.864 192.374H98.7008ZM95.3129 175.434V181.505H96.5272C97.6845 181.505 98.3907 180.997 98.3907 179.415V177.467C98.3907 176.055 97.9106 175.434 96.8103 175.434H95.3129Z",
    fill: "#38879F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.386 180.94H112.649V183.762H108.386V189.551H113.751V192.374H105.28V172.611H113.751V175.434H108.386V180.94Z",
    fill: "#38879F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.217 178.06H120.161V192.374H117.366V172.611H121.262L124.395 184.441H124.451V172.611H127.219V192.374H124.028L120.217 178.06Z",
    fill: "#38879F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M130.269 172.611H139.868V175.434H136.621V192.374H133.516V175.434H130.27V172.611H130.269Z",
    fill: "#38879F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M158.051 185.008V187.634C158.051 190.796 156.47 192.602 153.42 192.602C150.371 192.602 148.791 190.796 148.791 187.634V177.357C148.791 174.195 150.371 172.389 153.42 172.389C156.47 172.389 158.051 174.195 158.051 177.357V179.277H155.115V177.159C155.115 175.748 154.494 175.211 153.505 175.211C152.517 175.211 151.896 175.748 151.896 177.159V187.831C151.896 189.242 152.517 189.751 153.505 189.751C154.494 189.751 155.115 189.242 155.115 187.831V185.008H158.051Z",
    fill: "#38879F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.717 192.374H168.583L168.047 188.788H164.235L163.698 192.374H160.847L164.01 172.611H168.555L171.717 192.374ZM164.63 186.106H167.623L166.154 176.112H166.098L164.63 186.106Z",
    fill: "#38879F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M181.374 192.374C181.205 191.866 181.092 191.556 181.092 189.945V186.84C181.092 185.006 180.47 184.328 179.059 184.328H177.987V192.374H174.881V172.611H179.568C182.786 172.611 184.17 174.108 184.17 177.157V178.71C184.17 180.742 183.521 182.041 182.138 182.69V182.746C183.691 183.395 184.198 184.864 184.198 186.925V189.974C184.198 190.933 184.227 191.64 184.538 192.374H181.374ZM177.986 175.434V181.505H179.199C180.356 181.505 181.063 180.997 181.063 179.415V177.467C181.063 176.055 180.582 175.434 179.482 175.434H177.986Z",
    fill: "#38879F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.058 180.94H195.321V183.762H191.058V189.551H196.423V192.374H187.952V172.611H196.423V175.434H191.058V180.94Z",
    fill: "#38879F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3371_24536",
    x1: 28.138,
    y1: 68.727,
    x2: 175.895,
    y2: 94.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0628,
    stopColor: "#2F6C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2158,
    stopColor: "#204E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3655,
    stopColor: "#163855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5091,
    stopColor: "#0F2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6397,
    stopColor: "#0D2645"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3371_24536",
    x1: 28.0423,
    y1: 68.1782,
    x2: 176.316,
    y2: 83.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#489FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    stopColor: "#33758E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#22537B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4371,
    stopColor: "#1C4674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3371_24536",
    x1: 28.4088,
    y1: 59.6294,
    x2: 175.584,
    y2: 59.6294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#54B2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    stopColor: "#306D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3371_24536",
    x1: 101.556,
    y1: 101.972,
    x2: 101.556,
    y2: 6.74792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#479E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7126,
    stopColor: "#5ECCB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    stopColor: "#71E298"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3371_24536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.865 44.7705) scale(57.2874 57.2874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#51B188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#52B38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6805,
    stopColor: "#58C1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#5BC6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3371_24536",
    x1: 115.188,
    y1: 59.8307,
    x2: 163.077,
    y2: 97.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1632,
    stopColor: "#275B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#56BBC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3371_24536",
    x1: 67.845,
    y1: 90.0877,
    x2: 88.4593,
    y2: 62.7316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#5BC6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0758,
    stopColor: "#59C2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    stopColor: "#449695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#347681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#2A6275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#275B71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3371_24536",
    x1: 57.6187,
    y1: 103.372,
    x2: 146.028,
    y2: 103.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0611,
    stopColor: "#4AA1BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#1A426C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8193,
    stopColor: "#387EA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.131d817a02a5c99db05be2ba9303e7ae.svg";
export { ForwardRef as ReactComponent };